import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailTvsChildProps as Props } from './types';
import { getCompanyTvDetails } from '../../../services/companies';

export const Component: FunctionComponent<Props> = (props) => {
  const [updatedAt, setUpdatedAt] = useState<string>('');
  const [image, setImage] = useState<string | null>(null);
  const [tvTitle, setTvTitle] = useState<string>('');

  useEffect(() => {
    let aborted = false;

    const fetchTvDetail = async () => {
      try {
        const response = await getCompanyTvDetails(props.id);
        if (aborted) return;
        setUpdatedAt(response.updatedAt || '');
        setImage(response.image ?? null);
        setTvTitle(response.tvTitle || '');
      } catch (error) {
        console.log(error);
      }
    };

    fetchTvDetail();
    return () => { aborted = true; };
  }, [props.id]);

  return (
    <Presentation
      id={props.id}
      dataCategory={props.dataCategory}
      dataValue={props.dataValue}
      updatedAt={updatedAt}
      image={image}
      tvTitle={tvTitle}
    />
  );
};
